export const Tier2ActiveCollectibles = [
    ['The Book of Belial', '34'],
    ['Tammy\'s Head', '38'],
    ['Shoop Da Whoop!', '49'],
    ['We Need to Go Deeper!', '84'],
    ['Deck of Cards', '85'],
    ['The Gamekid', '93'],
    ['The Book of Sin', '97'],
    ['The Pinking Shears', '107'],
    ['A Pony', '130'],
    ['Crack the Sky', '160'],
    ['The Candle', '164'],
    ['D20', '166'],
    ['White Pony', '181'],
    ['Clear Rune', '263'],
    ['Blank Card', '286'],
    ['Red Candle', '289'],
    ['Head of Krampus', '293'],
    ['Converter', '296'],
    ['Pandora\'s Box', '297'],
    ['Undefined', '324'],
    ['The Boomerang', '338'],
    ['Placebo', '348'],
    ['Friendly Ball', '382'],
    ['D8', '406'],
    ['Jar of Flies', '434'],
    ['Compost', '480'],
    ['Potato Peeler', '487'],
    ['Sharp Straw', '507'],
    ['Sprinkler', '516'],
    ['Coupon', '521'],
    ['Sacrificial Altar', '536'],
    ['Fortune Cookie', '557'],
    ['Damocles', '577'],
    ['Alabaster Box', '585'],
    ['Mom\'s Bracelet', '604'],
    ['Larynx', '611'],
    ['Genesis', '622'],
    ['Eraser', '638'],
    ['Yuck Heart', '639'],
    ['Magic Skin', '642'],
    ['Plum Flute', '650'],
    ['Jar of Wisps', '685'],
    ['Esau Jr.', '703'],
    ['Keeper\'s Box', '719'],
    ['Everything Jar', '720'],
    ['Decap Attack', '729'],
];